import Env from 'common/env'
import config from './config.js'
export default {
    name: 'Icon',
    data () {
        return {
            list: config.list,
            iconColor: '',
            // isWechat: env.isWechat,
            hide: false,
            defaultIcon: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
        };
    },
    components: {
    },
    props: {
        name: String,
        color: {
            type: String,
            default: '#000000'
        },
        active: Boolean,
        width: {
            type: Number|String,
            default: 24
        },
        dark_color: {
            type: String,
            default: ''
        },
        origin: Boolean,

        styleObject: {
            type: Object,
            default () {
                return {
                }
            }
        }
    },
    watch: {
        color (newVal) {
            if(this.isCustom(newVal)) {
                this.iconColor = newVal
            }else {
                this.iconColor = '';
            }
        },
        dark_color (newVal) {
            if(this.isDarkMode && this.isCustom(newVal)) {
                this.iconColor = newVal
                setTimeout(() => {
                    this.iconColor = newVal
                }, 0)
            }
        },

        'styleObject.color' (newVal) {
            if(this.isCustom(newVal)) {
                this.iconColor = newVal
            }else {
                this.iconColor = '';
            }
        },

        'styleObject.dark_color' (newVal) {
            if(this.isDarkMode && this.isCustom(newVal)) {
                this.iconColor = newVal
                setTimeout(() => {
                    this.iconColor = newVal
                }, 0)
            }
        },

        isDarkMode (newVal) {
            if(newVal) {
                let color = this.getValue('dark_color')
                if(this.isCustom(color)) {
                    this.iconColor = color
                }
            }else {
                let color = this.getValue('color')
                if(this.isCustom(color)) {
                    this.iconColor = color
                }
            }
        }
    },
    computed: {
        icon () {
            let index = -1;
            for(let i = 0, len = this.list.length; i < len; i++) {
                if(this.list[i].name === this.getValue('name')) {
                    index = i;
                    break;
                }
            }
            if(index > -1) {
                if(this.list[index].customCdn) {
                    return `https://res.wx.qq.com/wechatgame/product/webpack/userupload/${this.getValue('active') ? this.list[index].activeUrl : this.list[index].url}`
                }else {
                    return `https://res.wx.qq.com/wechatgame/product/cdn/moment/${this.getValue('active') ? this.list[index].activeUrl : this.list[index].url}`
                }
            }else {
                return ''
            }
        },

        realOrigin () {
            return (this.styleObject && this.styleObject.origin) || this.origin
        },

        realWidth () {
            let width;
            if(Env.isCSR) {
                width = Env.getCSR().getSystemInfo().windowWidth;
            }else{
                width = document.documentElement.clientWidth;
            }
            let ratio = this.styleObject && this.styleObject.adapt && width < 359 ? 0.853 : 1
            return (this.styleObject && (this.styleObject.width * ratio)) || this.width
        },

        realColor () {
            return (this.styleObject && this.styleObject.color) || this.color
        }
        
    },
    created () {
        let color = this.getValue('color')
        if(this.isCustom(color)) {
            this.iconColor = color
        }else if(!color) {
            this.iconColor = '#000000'
        }
        if(this.isDarkMode && this.isCustom(this.getValue('dark_color'))) {
            this.iconColor = this.getValue('dark_color')
        }
    },
    methods: {
        isCustom (str = '') {
            return str && (str.indexOf('#') > -1 || str.indexOf('rgb') > -1)
        },

        getValue(name) {
            return (this.styleObject && this.styleObject[name]) || this[name]
        }
    }
}